import { Guest, Company, Statistics, RealtimeActivity } from '../types';

export const mockCompanies: Company[] = [
  { id: '1', name: 'Công ty TNHH ABC', floor: 5, elevatorZone: 'A' },
  { id: '2', name: 'Tập đoàn XYZ', floor: 8, elevatorZone: 'B' },
  { id: '3', name: 'Công ty Cổ phần DEF', floor: 12, elevatorZone: 'C' },
  { id: '4', name: 'Văn phòng Luật sư GHI', floor: 3, elevatorZone: 'A' },
  { id: '5', name: 'Công ty Tư vấn JKL', floor: 15, elevatorZone: 'C' },
  { id: '6', name: 'Ngân hàng MNO', floor: 10, elevatorZone: 'B' },
  { id: '7', name: 'Công ty IT PQR', floor: 7, elevatorZone: 'A' },
  { id: '8', name: 'Công ty Kiến trúc STU', floor: 6, elevatorZone: 'B' },
];

export const mockGuests: Guest[] = [
  // Case 1: Đã duyệt, đã cấp thẻ, đã check-in (có lịch sử đầy đủ)
  {
    id: '1',
    fullName: 'Nguyễn Văn An',
    idNumber: '001234567890',
    phoneNumber: '0901234567',
    email: 'nguyen.van.an@email.com',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
    company: 'Công ty TNHH ABC',
    contactPerson: 'Trần Thị B',
    visitReason: 'Họp dự án',
    registrationTime: new Date('2024-01-14T08:30:00'),
    status: 'approved',
    approvedBy: 'Admin',
    approvedTime: new Date('2024-01-14T08:35:00'),
    cardId: 'CARD001',
    floor: 5,
    elevatorZone: 'A',
    checkInTime: new Date('2024-01-14T09:15:00'),
    checkOutTime: new Date('2024-01-14T17:30:00'),
  },
  
  // Case 2: Chờ duyệt (pending) - chưa có gì khác
  {
    id: '2',
    fullName: 'Lê Thị Bình',
    idNumber: '001234567891',
    phoneNumber: '0901234568',
    email: 'le.thi.binh@email.com',
    photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
    company: 'Tập đoàn XYZ',
    contactPerson: 'Phạm Văn C',
    visitReason: 'Tư vấn pháp lý',
    registrationTime: new Date('2024-01-15T09:15:00'),
    status: 'pending',
  },
  
  // Case 3: Đã duyệt, đã cấp thẻ, chưa check-in (sẵn sàng cho turnstile)
  {
    id: '3',
    fullName: 'Trần Minh Cường',
    idNumber: '001234567892',
    phoneNumber: '0901234569',
    company: 'Công ty Cổ phần DEF',
    visitReason: 'Ký hợp đồng',
    registrationTime: new Date('2024-01-15T10:00:00'),
    status: 'approved',
    approvedBy: 'Admin',
    approvedTime: new Date('2024-01-15T10:05:00'),
    cardId: 'CARD002',
    floor: 12,
    elevatorZone: 'C',
  },
  
  // Case 4: Chờ duyệt (pending) - theo yêu cầu của bạn
  {
    id: '4',
    fullName: 'Phạm Thị Dung',
    idNumber: '001234567893',
    phoneNumber: '0901234570',
    email: 'pham.thi.dung@email.com',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    company: 'Văn phòng Luật sư GHI',
    contactPerson: 'Luật sư Hoàng',
    visitReason: 'Tư vấn pháp lý',
    registrationTime: new Date('2024-01-15T10:30:00'),
    status: 'pending',
  },
  
  // Case 5: Đã duyệt, chưa cấp thẻ (sẵn sàng cho reception)
  {
    id: '5',
    fullName: 'Hoàng Văn Nam',
    idNumber: '001234567894',
    phoneNumber: '0901234571',
    company: 'Ngân hàng MNO',
    contactPerson: 'Giám đốc Chi nhánh',
    visitReason: 'Thảo luận hợp tác',
    registrationTime: new Date('2024-01-15T11:00:00'),
    status: 'approved',
    approvedBy: 'Admin',
    approvedTime: new Date('2024-01-15T11:05:00'),
    floor: 10,
    elevatorZone: 'B',
  },
  
  // Case 6: Từ chối
  {
    id: '6',
    fullName: 'Vũ Thị Lan',
    idNumber: '001234567895',
    phoneNumber: '0901234572',
    company: 'Công ty IT PQR',
    visitReason: 'Không rõ mục đích',
    registrationTime: new Date('2024-01-15T11:30:00'),
    status: 'rejected',
    approvedBy: 'Admin',
    approvedTime: new Date('2024-01-15T11:35:00'),
  },
];

export const mockStatistics: Statistics = {
  currentInBuilding: 127,
  todayCheckIns: 89,
  todayCheckOuts: 62,
  peakHour: '09:00 - 10:00',
  floorBreakdown: [
    { floor: 3, count: 8 },
    { floor: 5, count: 15 },
    { floor: 6, count: 12 },
    { floor: 7, count: 20 },
    { floor: 8, count: 18 },
    { floor: 10, count: 25 },
    { floor: 12, count: 16 },
    { floor: 15, count: 13 },
  ],
  topCompanies: [
    { company: 'Tập đoàn XYZ', count: 25 },
    { company: 'Ngân hàng MNO', count: 20 },
    { company: 'Công ty IT PQR', count: 18 },
    { company: 'Công ty TNHH ABC', count: 15 },
    { company: 'Công ty Cổ phần DEF', count: 11 },
  ],
  hourlyData: [
    { hour: '08:00', checkIns: 12, checkOuts: 2 },
    { hour: '09:00', checkIns: 25, checkOuts: 5 },
    { hour: '10:00', checkIns: 18, checkOuts: 8 },
    { hour: '11:00', checkIns: 15, checkOuts: 12 },
    { hour: '12:00', checkIns: 8, checkOuts: 20 },
    { hour: '13:00', checkIns: 6, checkOuts: 8 },
    { hour: '14:00', checkIns: 5, checkOuts: 7 },
  ],
};

export const mockRealtimeActivity: RealtimeActivity[] = [
  {
    id: '1',
    guestName: 'Nguyễn Văn An',
    action: 'check-in',
    time: new Date('2024-01-14T09:15:00'),
    floor: 5,
  },
  {
    id: '2',
    guestName: 'Nguyễn Văn An',
    action: 'check-out',
    time: new Date('2024-01-14T17:30:00'),
    floor: 5,
  },
  {
    id: '3',
    guestName: 'Khách khác',
    action: 'check-in',
    time: new Date('2024-01-15T08:45:00'),
    floor: 8,
  },
];
